import { ETelemetryType } from '../types.js';
export class ConsoleTransport {
    send(sample) {
        const messageType = sample.type === ETelemetryType.COUNTER ? 'TELEMETRY.increment:' : 'TELEMETRY.timer:';
        // eslint-disable-next-line no-console
        console.log(messageType, sample.key, sample.value);
    }
}
//# sourceMappingURL=console.js.map